import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class DispatchEditRouteNamePanelComponent implements IController {
  panelRef: any;
  routeName: string;
  route?: any;
  pickingTimeOffsetInMinutes?: any;

  public routeNameCopy: string;
  public isEditRouteNameMode: boolean = false;

  public isEditPickingTimeMode: boolean = false;
  public routeStartTime: any;
  public startOfDay: any;
  public pickingTime: any;

  public routeMetaData: any[];
  public dynamicColumnsMap: any;
  public editableMetaData?: { key: string, value: string };

  constructor(private moment, private splitService: SplitService) {
  }

  $onInit() {
    if (!this.routeName) {
      this.routeName = 'Route';
    }
    if (this.route) {
      this._setPickingTime();
    }
    this._initRouteMetaData();
  }

  $onChanges(changes) {
    if (changes.route && this.route) {
      this._initRouteMetaData();
      this._setPickingTime();
    }
  }

  onEditRouteName() {
    this.isEditRouteNameMode = true;
    this.routeNameCopy = angular.copy(this.routeName);
  }

  onEditPickingTime() {
    this.isEditPickingTimeMode = true;
    this._setPickingTime();
  }

  onChangePickingTime(time) {
    this.pickingTime = time;
  }

  onSubmitRouteName(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.panelRef.config.onChangeRouteName(this.panelRef, this.routeNameCopy);
      }
    }
  }

  onSubmitPickingTime(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        const updatedPickingTimeOffsetInMinutes = (this.routeStartTime - this.pickingTime) / 60000;
        this.panelRef.config.onChangePickingTimeOffsetInMinutes(this.panelRef, (updatedPickingTimeOffsetInMinutes >= 0 ? updatedPickingTimeOffsetInMinutes : undefined));
      }
    }
  }

  onCancelRouteName() {
    this.isEditRouteNameMode = false;
    this.routeNameCopy = undefined;
  }

  onEditMetaData(key: string, value?: string) {
    this.editableMetaData = {key: key, value: value};
  }

  onCancelEditMetaData() {
    this.editableMetaData = undefined;
  }

  onEditableMetaDataValueChange(value) {
    this.editableMetaData.value = value;
  }

  onSaveMetaData(editableMetaData: { key: string, value: string }) {
    const metaDataPayload = [editableMetaData];
    const result = this.panelRef?.config?.onUpdateRouteMetaData?.(this.panelRef, metaDataPayload);

    if (result && result.then) {
      result.then((updatedRoute) => {
        this._applyRouteMetaData(updatedRoute);
      });
    }
  }

  private _applyRouteMetaData(updatedRoute) {
    if (updatedRoute?.metaData) {
      this.route.metaData = updatedRoute.metaData;
    }
    this.dynamicColumnsMap = _.mapKeys(this.route?.metaData, (value) => {
      return value.key;
    });
    this.editableMetaData = undefined;
  }

  private _initRouteMetaData() {
    this.routeMetaData = this.splitService.getRoutesMetadataSettings() || [];
    this.dynamicColumnsMap = _.mapKeys(this.route?.metaData, (value) => {
      return value.key;
    });
  }

  private _setPickingTime() {
    this.routeStartTime = _.get(this.route, 'routeTaskList[0].routeAnalysis.eta', this.route.notBefore);
    this.startOfDay = this.moment(this.routeStartTime).startOf('day').valueOf()

    this.pickingTime = this.pickingTimeOffsetInMinutes ?
      (this.routeStartTime - (this.pickingTimeOffsetInMinutes * 60000)) :
      this.routeStartTime;
  }

}

angular
.module('bringoz.admin.commons')
.component('dispatchEditRouteNamePanel', {
  bindings: {
    panelRef: '<',
    ngPlaceholder: '<?',
    routeName: '<?',
    route: '<?',
    pickingTimeOffsetInMinutes: '<?'
  },
  template: require('./dispatch-edit-route-name-panel.html').default,
  controller: DispatchEditRouteNamePanelComponent
});
